export default "__VITE_ASSET__A0yk3b4O__"